import { OptionCard, OptionCardRow, StepShell } from './optionCard';

/**
 * Note on the `name` / `data-name` attributes below: the download and delete
 * handlers resolve which sign was acted on with
 * `e.target.name || e.currentTarget.getAttribute('data-name')`, and the drop handler
 * reads `e.currentTarget.dataset.name`. They are load-bearing, not decoration.
 */
const QuestionareComponent = ({title, name, _option, _image, image_title, sign_download_link, sign_download_name, sign_download_title, handleYes, handleNo, handleDownload, handleDelete, handleFileChange}) => {
    return (
        <StepShell>
            <h3 className="text-center text-lg font-semibold text-[#0a1445] sm:text-xl">
                {title}
            </h3>

            <OptionCardRow>
                {/* Yes Option */}
                <OptionCard selected={_option === 'Yes'} onClick={handleYes}>
                    Yes
                </OptionCard>

                {/* No Option */}
                <OptionCard selected={_option === 'No'} onClick={handleNo}>
                    No
                </OptionCard>
            </OptionCardRow>

            { _option === 'Yes' && ((_image && _image !== 'null') ? (
                                <div className="mb-4 mt-10 grid w-full max-w-md grid-cols-3 items-center justify-between gap-2 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
                                        <p className="col-span-2 truncate text-sm font-semibold text-[#211b4f]">
                                            {_image.split("/").pop()}
                                        </p>
                                        <div className="col-span-1 flex justify-end">
                                            <button
                                                name={name}
                                                onClick={handleDownload}
                                                className="inline-flex h-9 w-9 items-center justify-center rounded-lg fill-current text-[#211b4f] transition-colors hover:bg-[#211b4f]/5"
                                            >
                                                <svg data-name={name} onClick={handleDownload} xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                                    <path d="M0 0h24v24H0z" fill="none"/>
                                                    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                                                </svg>
                                            </button>
                                            <button
                                                name={name}
                                                onClick={handleDelete}
                                                className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-red-600 transition-colors hover:bg-red-50"
                                            >
                                                <svg data-name={name} onClick={handleDelete} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                                                </svg>
                                            </button>
                                    </div>
                                </div>
                            ) : (
                                <div data-name={name} className="mt-10 flex w-full max-w-md items-center justify-center"
                                    onDragOver={(e) => {e.preventDefault(); e.stopPropagation()}}
                                    onDragEnter={(e) => {e.preventDefault(); e.stopPropagation()}}
                                    onDragLeave={(e) => {e.preventDefault(); e.stopPropagation()}}
                                    onDrop={(e) => { e.preventDefault(); e.stopPropagation(); handleFileChange(e)}}
                                    >
                                    <label htmlFor={name} className="flex w-full cursor-pointer flex-col items-center justify-center rounded-2xl border-2 border-dashed border-slate-300 bg-slate-50 transition-colors hover:border-[#fb6635] hover:bg-orange-50">
                                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                            <svg className="mb-4 h-8 w-8 text-slate-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"/>
                                            </svg>
                                            <p className="mb-2 px-4 text-center text-sm text-slate-500"><span className="font-semibold">Click to upload {image_title}</span> </p>
                                            <p className="mb-2 text-sm text-slate-500">or drag and drop</p>
                                        </div>
                                        <input name={name} onChange={handleFileChange} id={name} type="file" className="hidden" />
                                    </label>
                                </div>
                            ))
            }

            {_option === 'No' && (
                <a href={sign_download_link} download={sign_download_name} className="mt-6 text-center text-base font-medium text-[#fb6635] underline decoration-orange-200 underline-offset-2 hover:decoration-[#fb6635] sm:text-lg">
                    {sign_download_title}
                </a>
            )}

        </StepShell>
    )
}


export default QuestionareComponent;
